module.exports = __webpack_public_path__ + "img/yk.81f27a8c.jpg";